import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'pagination-simplified',
  templateUrl: 'pagination-simplified.component.html'
})
export class PaginationSimplifiedComponent {
  @Input() isPrevDisabled: boolean = false;
  @Input() isNextDisabled: boolean = false;
  @Input() showPages: boolean = false;
  @Input() currentPage: number;
  @Input() totalPages: number;

  @Output() clicked = new EventEmitter<number>();

  onPaginationBtnClick(event: MouseEvent, direction: number) {
    event.preventDefault();
    if (direction === 1 && this.isNextDisabled) { return; }
    if (direction === -1 && this.isPrevDisabled) { return; }
    this.clicked.emit(direction);
  }

}
